module.exports = __webpack_public_path__ + "static/img/error-500.a371eabc.svg";